<template>
  <div>
    <pulse-loader :loading="isUserData" :color="color" :size="size"></pulse-loader>
    <div v-if="!isUserData" class="header">
      <div class="header_data">
        <div class="user_data">
          <i class="fas fa-user-tie"></i>
          <p>{{ getUserEmail }}:</p>
          <span v-if="isAvailable(['welder', 'customer'])">{{ getUserBalance || 0 }}₽</span>
        </div>
        <div class="header_nav">
          <div v-if="isAvailable(['admin'])" class="nav_item">
            <i class="fas fa-tools"></i>
            <router-link :to="{ name: 'Admin' }">Администрирование</router-link>
          </div>
          <div v-if="isAvailable(['admin', 'welder'])" class="nav_item">
            <i class="fas fa-city"></i>
            <router-link :to="{ name: 'analyticsCount' }">Статистика</router-link>
          </div>
          <div class="nav_item">
            <i class="fas fa-home"></i>
            <router-link :to="{ name: 'Table' }">Главная</router-link>
          </div>
          <div class="nav_item">
            <i class="fas fa-user-cog"></i>
            <router-link :to="{ name: 'Account' }">Личный кабинет</router-link>
          </div>
        </div>
      </div>


      <div class="header_logout" @click="logout">
        <i class="fas fa-sign-out-alt"></i>
        <span>Выйти</span>
      </div>
    </div>
  </div>


</template>

<script>
import {mapGetters} from "vuex";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "Nav",
  computed: {
    ...mapGetters(['isUserData', 'getUserBalance', 'getUserEmail', 'meRoles']),
  },
  data() {
    return {
      loading: true,
      color: "#2c3e50",
      size: "10px"
    };
  },

  methods: {
    logout: async function () {
      this.$store.commit('logout')
      localStorage.removeItem('access_token')
      localStorage.removeItem('user_data')
      delete this.axios.defaults.headers.common['Authorization']
      await this.$router.push('/login')
    },
    isAvailable(roles) {
      return this.meRoles.map(item => roles.includes(item)).includes(true)
    }
  },
  components: {PulseLoader},
}
</script>

<style scoped>
.header {
  padding: 10px 5%;
  color: #000;
  box-shadow: 0 2px 6px 0 rgb(32 33 37 / 10%);
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  align-items: center;
}

.header_data {
  color: #000;
  display: flex;
  align-items: center;
  width: 100%;
}

.header_nav {
  display: flex;
  align-items: center;
}

.header_nav .nav_item {
  display: flex;
  align-items: center;
  margin: 0 15px;
  border-radius: 10px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  font-size: 14px;

}

.header_nav .nav_item a {
  color: #222;
  text-decoration: none;
  font-size: 14px;
}

.header_data i {
  font-size: 18px;
  margin-right: 5px;
}

.user_data {
  display: flex;
  align-items: center;
  margin-right: auto;
  border-radius: 5px;
  border: 1px dashed #0d6efd;
  padding: 5px 10px;
}

.user_data span {
  font-size: 12px;
  margin-left: 5px;
  font-weight: 500;
  color: #555;
}

.header_data p {
  margin-bottom: 0;
  font-size: 14px;
}

.header_logout {
  margin-left: 30px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #e42b63;
  padding: 5px;
  /* background: #e42b63; */
  font-size: 12px;
  /* color: #fff; */
  cursor: pointer;
  opacity: .5;
  transition: all .2s ease;
}

.header_logout:hover {
  opacity: 1;
  box-shadow: 1px 2px 14px 0 rgb(228 43 99 / 20%);
}

.header_logout i {
  margin-right: 5px;
}
</style>
